import type { ComponentProps } from "react";
import { cn } from "~/lib/utils";

type IconBadgeProps = ComponentProps<"span">;

export function IconBadge({ children, className, ...props }: IconBadgeProps) {
  return (
    <span className={cn("shrink-0 rounded-full bg-secondary p-1 text-secondary-foreground", className)} {...props}>
      {children}
    </span>
  );
}
